import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { isNoindexCategory } from '@core/application/use-cases/seo/is-no-index-category.use-case';
import { getFreeTextAttachment } from '@features/category/application/services/category.utils';
import { MenuCategory, freeTextAttachments } from '@shared/header/models/category.model';
import { ActiveCategoriesTree } from '@shared/menu-categories/store/menu-categories.state';

@Component({
    selector: 'li [header-menu-subcategory]',
    templateUrl: './header-menu-subcategory.component.html',
    styleUrls: ['./header-menu-subcategory.component.scss'],
})
export class HeaderMenuSubcategoryComponent implements OnInit {
    @Input() public indexItem: number;

    @Input() public subCategory: MenuCategory;

    @Input() public activeCategories: Record<number, ActiveCategoriesTree>;

    @Input() public sectionIndex: number;

    @Input() public sectionName: string;

    @Input() public isRtl = false;

    @Input() public debugShowCategoryId: boolean;

    @Input() public showChilds = true;

    @Input() public level = 2;

    @Output() public readonly sendOpenSubCategory = new EventEmitter();

    public freeTextAttachments: freeTextAttachments[];

    public isNoindex: boolean;

    public ngOnInit(): void {
        this.freeTextAttachments = getFreeTextAttachment(this.subCategory);
        this.isNoindex = isNoindexCategory(this.subCategory.attachments);
    }

    public openSubCategory($event: MouseEvent, category: MenuCategory) {
        $event.preventDefault();
        $event.stopPropagation();
        this.sendOpenSubCategory.emit(category);
    }
}
